import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ProfileService } from '../services/profile-service/profile.service';

@Injectable({
    providedIn: 'root'
})
export class AdherentActifGuard implements CanActivate {
    constructor(
        private profileService: ProfileService,
        private router: Router
    ) {}

    canActivate(): Observable<boolean> {
        return this.profileService.getAdherentType().pipe(
            map((res: any) => {
                const adhType = res?.ADH_TYPE?.toLowerCase();
                // Allow access ONLY if type is exactly 'inactif'
                if (adhType !== 'inactif') {
                    this.router.navigate(['/dashboard']);
                    return false;
                }
                return true;
            }),
            catchError((error) => {
                console.warn('AdherentActifGuard: API error, blocking access to cotisations:', error);
                this.router.navigate(['/dashboard']);
                return of(false);
            })
        );
    }
}
